import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect, useState } from "react";

import { usePortStatusQuery } from "~/hooks/usePortStatus";

import { BinAnimationCategory } from "./BinState";

const inGridModes = ["G", "C", "F", "R", "X", "T"];

/**
 * @returns The current bin animation category or null
 * @returns The current bin activity state
 * @returns The number of bins above
 */
export const useBinAnimation = (portId: number, portSideIndex?: number) => {
  const { binAnimationWithoutDefaultState } = useFlags();
  const [animationCategory, setAnimationCategory] =
    useState<BinAnimationCategory | null>(
      binAnimationWithoutDefaultState ? null : "In Grid"
    );

  const { binState, activityState, isReady } = usePortStatusQuery(
    portId,
    portSideIndex
  );
  const xPosition = binState?.binState.xPosition;
  const yPosition = binState?.binState.yPosition;
  const binMode = binState?.binState.binMode;
  const binPortId = binState?.binState.portId;
  const binsAbove = binState?.binsAbove;

  const isAtAnotherPortModes = binMode === "O" || binMode === "P";
  const isXAndYZero = xPosition === 0 && yPosition === 0;
  const isCorrectPortId = binPortId === portId;

  const isOpenAtAnotherPort =
    isAtAnotherPortModes && binPortId !== 0 && !isCorrectPortId;
  const inGrid = binMode && inGridModes.includes(binMode) && !isXAndYZero;
  const onRobot = isXAndYZero;
  const inPort = binMode === "P" && !isXAndYZero;
  const isOpen = isReady;

  useEffect(() => {
    if (isOpen) {
      setAnimationCategory(null);
    } else if (isOpenAtAnotherPort) {
      setAnimationCategory("Other Port");
    } else if (inGrid) {
      setAnimationCategory("In Grid");
    } else if (onRobot) {
      setAnimationCategory("On Robot");
    } else if (inPort) {
      setAnimationCategory("In Port");
    }
  }, [inGrid, inPort, isOpen, isOpenAtAnotherPort, onRobot]);

  return {
    animationCategory,
    activityState,
    binsAbove
  };
};
